module.exports = __webpack_public_path__ + "static/media/20.2af9a337.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/20.png
// module id = 1518
// module chunks = 0